<template>
  <div class="proposal">
    <dna-wrapper>
      <dna-council-pic></dna-council-pic>
      <dna-network-parameter-table></dna-network-parameter-table>
    </dna-wrapper>
  </div>
</template>

<script>
import dnaCouncilPic from '@/components/ProposalPicShow/ProposalPicShow.vue'
import dnaNetworkParameterTable from '@/components/NetworkParameterTable/NetworkParameterTable.vue'
export default {
  components: {
    dnaCouncilPic,
    dnaNetworkParameterTable
  }
}
</script>

<style lang="less" scoped>
@import url('./Proposal.less');
</style>